import {
  ADD_PROJECT_FAVORITE,
  ADD_PROJECT_FAVORITE_SUCCESS,
  ARCHIVE_SERVICE_MAP,
  CONNECT_PROJECT_WEBMASTER,
  CONNECT_PROJECT_GOOGLE_SEARCH,
  CONNECT_PROJECT_GOOGLE_SEARCH_SUCCESS,
  SELECT_PROJECT_GOOGLE_SEARCH,
  CREATE_PROJECT_SUCCESS,
  CREATE_TEAM_MAP,
  CREATE_TEAM_MAP_SUCCESS,
  DELETE_PROJECT,
  DELETE_PROJECT_FAVORITE,
  DELETE_PROJECT_FAVORITE_SUCCESS,
  DELETE_PROJECT_SUCCESS,
  DELETE_SERVICE_MAP,
  DELETE_SERVICE_MAP_SUCCESS,
  DELETE_TEAM_MAP,
  DELETE_TEAM_MAP_SUCCESS,
  LOAD_PROJECT_BY_ID,
  LOAD_PROJECT_BY_ID_SUCCESS,
  LOAD_PROJECT_FILE_LIST,
  LOAD_PROJECT_FILE_LIST_SUCCESS,
  LOAD_PROJECTS,
  LOAD_PROJECTS_DRIVE_FOLDERS,
  LOAD_PROJECTS_DRIVE_FOLDERS_SUCCESS,
  LOAD_PROJECTS_FAVORITE_MAP,
  LOAD_PROJECTS_FAVORITE_MAP_SUCCESS,
  LOAD_PROJECTS_NAME,
  LOAD_PROJECTS_NAME_SUCCESS,
  LOAD_PROJECTS_SERVICES_MAP,
  LOAD_SERVICE_ANALYTICS_SUCCESS,
  LOAD_PROJECTS_SERVICES_MAP_SUCCESS,
  LOAD_PROJECTS_SUCCESS,
  SYNC_PROJECT_DRIVE,
  SYNC_PROJECT_DRIVE_SUCCESS,
  UPDATE_PROJECT,
  UPDATE_PROJECT_STATUS,
  UPDATE_PROJECT_SUCCESS,
  UPDATE_SERVICE_MAP,
  UPDATE_SERVICE_MAP_SUCCESS,
  UPDATE_PROJECT_MONITORING_SETTINGS,
  UPDATE_PROJECT_MONITORING_SETTINGS_SUCCESS,
  RUN_PROJECT_MONITORING,
  RUN_PROJECT_MONITORING_SUCCESS,
  LOAD_PROJECTS_IMPORTANT_PAGES,
  LOAD_PROJECTS_IMPORTANT_PAGES_SUCCESS,
  UPDATE_PROJECTS_IMPORTANT_PAGE,
  UPDATE_PROJECTS_IMPORTANT_PAGE_SUCCESS,
  DELETE_PROJECTS_IMPORTANT_PAGE,
  DELETE_PROJECTS_IMPORTANT_PAGE_SUCCESS,
  UNSET_PROJECT_INTEGRATION,
  BATCH_UPDATE_PROJECTS_IMPORTANT_PAGE,
  BATCH_UPDATE_PROJECTS_IMPORTANT_PAGE_SUCCESS,
  LOAD_PROJECT_SERVICE_HISTORY,
  LOAD_PROJECT_SERVICE_HISTORY_SUCCESS,
  UPDATE_PROJECT_SERVICE_HISTORY,
  UPDATE_PROJECT_SERVICE_HISTORY_SUCCESS,
} from 'constants/ActionTypes';
import { getIntlMessage } from 'helpers/utilHelpers';
import { toggleProjectForm } from 'actions/ui/projectListActions';
import { toggleProjectImportantPageForm } from 'actions/ui/formActions';
import { getSearch } from 'selectors/settingsSelectors';

// Begin loading of the project by id
export const loadProjectById = (projectId, payload = {}) => {
  return {
    type: LOAD_PROJECT_BY_ID,
    payload: {
      extraFields: [
        'client',
        'services',
        'yandexStatistics',
        'clientProfiles',
        'yandexMetrika',
        'lastTasks',
        'googleDriveLink',
      ],
      resource: 'projects/' + projectId,
      onSuccess: loadProjectByIdSuccess,
      onErrorMessage: getIntlMessage('project.load.error'),
      ...payload,
    },
  };
};

// Update project by id if loading is succeed
export const loadProjectByIdSuccess = (project) => {
  return {
    type: LOAD_PROJECT_BY_ID_SUCCESS,
    project,
  };
};

// Begin loading of the projects
export const loadProjects = (payload = {}) => {
  return {
    type: LOAD_PROJECTS,
    payload: {
      resource: 'projects',
      onSuccess: (response) => loadProjectsSuccess(response),
      onErrorMessage: getIntlMessage('project.load.error'),
      ...payload,
    },
  };
};

// Update projects if loading is succeed
export const loadProjectsSuccess = (projects, fromList = false) => {
  return {
    type: LOAD_PROJECTS_SUCCESS,
    projects,
    fromList,
  };
};

// Begin loading of the projects name
export const loadProjectsName = (payload = {}) => {
  return {
    type: LOAD_PROJECTS_NAME,
    payload: {
      fields: ['projectId', 'name'],
      perPage: 0,
      resource: 'projects',
      onSuccess: loadProjectsNameSuccess,
      onErrorMessage: getIntlMessage('project.load.error'),
      ...payload,
    },
  };
};

// Update projects name if loading is succeed
export const loadProjectsNameSuccess = (projects) => {
  return {
    type: LOAD_PROJECTS_NAME_SUCCESS,
    projects,
  };
};

// Begin loading of the projects services map
export const loadProjectsServicesMap = (payload = {}) => {
  return {
    type: LOAD_PROJECTS_SERVICES_MAP,
    payload: {
      resource: 'project-service-maps',
      onSuccess: loadProjectsServicesMapSuccess,
      onErrorMessage: getIntlMessage('project.load.error'),
      ...payload,
    },
  };
};

// Update projects services map if loading is succeed
export const loadProjectsServicesMapSuccess = (projectsServicesMap) => {
  return {
    type: LOAD_PROJECTS_SERVICES_MAP_SUCCESS,
    projectsServicesMap,
  };
};

// Success action for service analytics
export const loadServiceAnalyticsSuccess = (projectsServicesMap) => {
  return {
    type: LOAD_SERVICE_ANALYTICS_SUCCESS,
    projectsServicesMap,
  };
};

// Action load ProjectServiceHistory[] by ProjectServiceMap.relationId
export const loadProjectServiceHistory = (payload = {}) => {
  return {
    type: LOAD_PROJECT_SERVICE_HISTORY,
    payload: {
      resource: `project-service-history/${payload.values.relationId}`,
      onSuccess: loadProjectServiceHistorySuccess,
      onErrorMessage: getIntlMessage('request.error'),
      ...payload,
    },
  };
};

// Success action for loadProjectServiceHistory
const loadProjectServiceHistorySuccess = (response) => {
  return {
    type: LOAD_PROJECT_SERVICE_HISTORY_SUCCESS,
    response,
  };
};

// Action update ProjectServiceHistory
export const updateProjectServiceHistory = (payload = {}, values = {}) => {
  return {
    type: UPDATE_PROJECT_SERVICE_HISTORY,
    payload: {
      resource: 'project-service-history',
      onSuccess: updateProjectServiceHistorySuccess,
      entityPrimaryKey: 'historyId',
      ...payload,
    },
    values,
  };
};

// Success action for updateProjectServiceHistory
const updateProjectServiceHistorySuccess = (response) => {
  return {
    type: UPDATE_PROJECT_SERVICE_HISTORY_SUCCESS,
    response,
  };
};

// Project update request
export const updateProject = (values, payload = {}) => {
  return {
    type: UPDATE_PROJECT,
    payload: {
      resource: 'projects',
      onSuccess: updateProjectSuccess,
      afterSuccess: toggleProjectForm,
      entityPrimaryKey: 'projectId',
      ...payload,
    },
    values,
  };
};

// Project create request
export const createProject = (values, payload = {}) => {
  return {
    type: UPDATE_PROJECT,
    payload: {
      resource: 'projects',
      onSuccessMessage: getIntlMessage('project.message.createSuccess'),
      onErrorMessage: getIntlMessage('project.message.createError'),
      entityPrimaryKey: 'projectId',
      ...payload,
    },
    values,
  };
};

// Project create success
export const createProjectSuccess = (project) => {
  return {
    type: CREATE_PROJECT_SUCCESS,
    project,
  };
};

// Project update success
export const updateProjectSuccess = (project) => {
  return {
    type: UPDATE_PROJECT_SUCCESS,
    project,
  };
};

// Service map update request
export const updateServiceMap = (values, resolve, reject, onSuccessFunction = null) => {
  return {
    type: UPDATE_SERVICE_MAP,
    promise: { resolve, reject },
    payload: {
      resource: 'project-service-maps',
      onSuccess: updateServiceMapSuccess,
      entityPrimaryKey: 'relationId',
      extraFields: ['teamMaps', 'lastHistories'],
      onSuccessFunction,
    },
    values,
  };
};

// Service map update request
export const archiveServiceMap = (relationId, endDate = null) => {
  return {
    type: ARCHIVE_SERVICE_MAP,
    payload: {
      resource: `project-service-maps/${relationId}/archive`,
      onSuccess: updateServiceMapSuccess,
      onErrorMessage: getIntlMessage('service.message.archiveError'),
      method: 'PUT',
      extraFields: ['teamMaps', 'lastHistories'],
    },
    values: { relationId, endDate },
  };
};

// Service map update success
export const updateServiceMapSuccess = (serviceMap) => {
  return {
    type: UPDATE_SERVICE_MAP_SUCCESS,
    serviceMap,
  };
};

// Sending a request to the server to delete service map
export const deleteServiceMap = (relationId) => {
  return {
    type: DELETE_SERVICE_MAP,
    payload: {
      resource: 'project-service-maps',
      entityId: relationId,
      onSuccess: deleteServiceMapSuccess,
      onErrorMessage: getIntlMessage('request.error'),
    },
  };
};

// Delete service map if sending succeed
export const deleteServiceMapSuccess = (relationId) => {
  return {
    type: DELETE_SERVICE_MAP_SUCCESS,
    relationId,
  };
};

// Project status update request
export const updateProjectStatus = (projectId, status, extraFields = []) => {
  return {
    type: UPDATE_PROJECT_STATUS,
    payload: {
      method: 'PUT',
      resource: `projects/${projectId}/status`,
      onSuccess: updateProjectSuccess,
      extraFields,
    },
    values: { status },
  };
};

// Project team map create request
export const createTeamMap = (values, payload = {}) => {
  return {
    type: CREATE_TEAM_MAP,
    payload: {
      resource: 'project-team-maps',
      onSuccess: createTeamMapSuccess,
      entityPrimaryKey: 'mapId',
      ...payload,
    },
    values,
  };
};

// Project team map create success
export const createTeamMapSuccess = (teamMap) => {
  return {
    type: CREATE_TEAM_MAP_SUCCESS,
    teamMap,
  };
};

// Project team map delete request
export const deleteTeamMap = (mapId) => {
  return {
    type: DELETE_TEAM_MAP,
    payload: {
      resource: 'project-team-maps',
      entityId: mapId,
      onSuccess: deleteTeamMapSuccess,
      onErrorMessage: getIntlMessage('request.error'),
    },
  };
};

// Project team map delete success
export const deleteTeamMapSuccess = (mapId) => {
  return {
    type: DELETE_TEAM_MAP_SUCCESS,
    mapId,
  };
};

// Action for send request for connect project yandex webmaster
export const connectProjectWebmaster = (payload) => {
  return {
    type: CONNECT_PROJECT_WEBMASTER,
    payload: {
      resource: 'projects/project-token',
      hideLoader: true,
      ...payload,
    },
  };
};

// Action send request for connect project in google search console by code
export const connectProjectGoogleSearch = (payload) => {
  return {
    type: CONNECT_PROJECT_GOOGLE_SEARCH,
    payload: {
      resource: 'projects/save-search-token',
      hideLoader: true,
      onSuccess: connectGoogleSearchSuccess,
      ...payload,
    },
  };
};

// Action send request for connect project in google search console by select site
export const selectGoogleProject = (projectId, site, payload) => {
  return {
    type: SELECT_PROJECT_GOOGLE_SEARCH,
    payload: {
      resource: 'projects/select-google-project',
      queryParams: { select: site, projectId },
      hideLoader: true,
      onSuccess: connectGoogleSearchSuccess,
      ...payload,
    },
  };
};

const connectGoogleSearchSuccess = (response, action) => {
  let projectId = null;
  // Connect project google search action params
  if (action?.payload?.queryParams?.state) {
    projectId = action?.payload?.queryParams?.state;
  }
  // Select google project action params
  if (action?.payload?.queryParams?.projectId) {
    projectId = action?.payload?.queryParams?.projectId;
  }
  return {
    type: CONNECT_PROJECT_GOOGLE_SEARCH_SUCCESS,
    isGoogleSearchConnected: response === true,
    projectId,
  };
};

// Action for send request in delete project
export const deleteProject = (projectId) => {
  return {
    type: DELETE_PROJECT,
    payload: {
      resource: 'projects',
      entityId: projectId,
      onSuccess: deleteProjectSuccess,
      onErrorMessage: getIntlMessage('request.error'),
    },
  };
};

// Success action for delete project by projectId
const deleteProjectSuccess = (projectId) => {
  return {
    type: DELETE_PROJECT_SUCCESS,
    projectId,
  };
};

// Send request for update task meta
export const updateProjectMeta = (payload = {}) => {
  return {
    type: UPDATE_PROJECT,
    payload: {
      resource: `projects/${payload.values.projectId}/meta`,
      onSuccess: updateProjectSuccess,
      method: 'PUT',
    },
    values: payload.values,
  };
};

// Send request for update task meta
export const unsetProjectIntegration = (projectId, integration) => {
  return {
    type: UNSET_PROJECT_INTEGRATION,
    payload: {
      resource: `projects/${projectId}/unset-integration`,
      onSuccess: updateProjectSuccess,
      method: 'PUT',
    },
    values: { integration },
  };
};

// Send request for update monitoring settings
export const updateProjectMonitoringSettings = (values) => {
  return {
    type: UPDATE_PROJECT_MONITORING_SETTINGS,
    payload: {
      resource: `projects/monitoring-settings`,
      onSuccess: updateProjectMonitoringSettingsSuccess,
      onSuccessMessage: getIntlMessage('project.monitoring.setting.success'),
      onErrorMessage: getIntlMessage('request.error'),
    },
    values,
  };
};

// Project update monitoring settings success
export const updateProjectMonitoringSettingsSuccess = (values) => {
  return {
    type: UPDATE_PROJECT_MONITORING_SETTINGS_SUCCESS,
    values,
  };
};

// Send request for run monitoring
export const runProjectMonitoring = (projectId, name, onSuccessFunction, payload = {}) => {
  return {
    type: RUN_PROJECT_MONITORING,
    payload: {
      resource: `projects/${projectId}/run-monitoring`,
      onSuccess: runProjectMonitoringSuccess,
      queryParams: { name },
      onSuccessFunction,
      onErrorFunction: onSuccessFunction,
      onSuccessMessage: getIntlMessage('project.monitoring.run.success'),
      onErrorMessage: getIntlMessage('request.error'),
      ...payload,
    },
  };
};

const runProjectMonitoringSuccess = (statistic) => {
  return {
    type: RUN_PROJECT_MONITORING_SUCCESS,
    statistic,
  };
};

// Project update request
export const addProjectFavorite = (values) => ({
  type: ADD_PROJECT_FAVORITE,
  values,
  payload: {
    resource: 'project-favorite-maps',
    onSuccess: addProjectFavoriteSuccess,
  },
});

const addProjectFavoriteSuccess = (favoriteMap) => ({
  type: ADD_PROJECT_FAVORITE_SUCCESS,
  favoriteMap,
});

// Project update request
export const deleteProjectFavorite = (values, meta) => ({
  type: DELETE_PROJECT_FAVORITE,
  payload: {
    resource: `project-favorite-maps`,
    entityId: values.entityId,
    queryParams: { entity: values.entity },
    onSuccess: () => deleteProjectFavoriteSuccess(values, meta),
    onErrorMessage: getIntlMessage('request.error'),
  },
  values,
  meta,
});

const deleteProjectFavoriteSuccess = (values, meta) => ({
  type: DELETE_PROJECT_FAVORITE_SUCCESS,
  values,
  meta,
});

// Begin loading of the projects favorite map
export const loadProjectsFavoriteMap = () => {
  return {
    type: LOAD_PROJECTS_FAVORITE_MAP,
    payload: {
      resource: 'project-favorite-maps',
      perPage: 0,
      onSuccess: loadProjectsFavoriteMapSuccess,
      onErrorMessage: getIntlMessage('project.load.error'),
    },
  };
};

// Update projects favorites map if loading is succeed
export const loadProjectsFavoriteMapSuccess = (projectsFavoriteMap) => {
  return {
    type: LOAD_PROJECTS_FAVORITE_MAP_SUCCESS,
    projectsFavoriteMap,
  };
};

// Begin loading of the projects file list
export const loadProjectFileList = (projectId, page, onLoading, extensionFilter) => {
  return {
    type: LOAD_PROJECT_FILE_LIST,
    payload: {
      resource: 'projects/' + projectId + '/file-list',
      page,
      onLoading,
      extraFields: ['entityInfo', 'canDelete'],
      onSuccess: loadProjectFileListSuccess,
      onErrorMessage: getIntlMessage('project.load.error'),
      filters: {
        search: {
          selector: getSearch,
        },
        extension: {
          value: extensionFilter,
        },
      },
    },
  };
};

// Update projects file list if loading is succeed
export const loadProjectFileListSuccess = (fileList) => {
  return {
    type: LOAD_PROJECT_FILE_LIST_SUCCESS,
    fileList,
  };
};

// Handles loading of google drive folders list for project form
export const loadProjectsDriveFolders = () => {
  return {
    type: LOAD_PROJECTS_DRIVE_FOLDERS,
    payload: {
      resource: 'projects/drive-folders-list',
      onSuccess: loadProjectsDriveFoldersSuccess,
    },
  };
};
// Handles loading of google drive root folders to select one with projects in it in company form.
export const loadProjectsRootFolders = () => {
  return {
    type: LOAD_PROJECTS_DRIVE_FOLDERS,
    payload: {
      resource: 'projects/drive-folders-list',
      queryParams: {
        isCompany: true,
      },
      onSuccess: loadProjectsDriveFoldersSuccess,
    },
  };
};
export const loadProjectsDriveFoldersSuccess = (folders) => {
  return {
    type: LOAD_PROJECTS_DRIVE_FOLDERS_SUCCESS,
    folders,
  };
};

// Handles synchronizing of project team accesses to project folder.
export const syncProjectDrive = (projectId, payload = {}) => {
  return {
    type: SYNC_PROJECT_DRIVE,
    extra: { projectId },
    payload: {
      resource: `projects/${projectId}/sync-drive`,
      onSuccess: syncProjectDriveSuccess,
      onSuccessMessage: getIntlMessage('project.driveSync.success'),
      onErrorMessage: getIntlMessage('project.driveSync.error'),
      ...payload,
    },
  };
};
export const syncProjectDriveSuccess = (_, action) => {
  return {
    type: SYNC_PROJECT_DRIVE_SUCCESS,
    projectId: action.extra.projectId,
  };
};

// Begin loading of the projects important pages
export const loadProjectsImportantPages = (projectId, payload = {}) => {
  return {
    type: LOAD_PROJECTS_IMPORTANT_PAGES,
    payload: {
      resource: 'project-important-pages',
      onSuccess: loadProjectsImportantPagesSuccess,
      onErrorMessage: getIntlMessage('project.load.error'),
      filters: {
        projectId: {
          value: projectId,
        },
      },
      ...payload,
    },
  };
};

// Update projects important pages if loading is succeed
export const loadProjectsImportantPagesSuccess = (pages) => {
  return {
    type: LOAD_PROJECTS_IMPORTANT_PAGES_SUCCESS,
    pages,
  };
};

// Begin updating of the projects important pages
export const updateProjectsImportantPages = (values = {}, payload = {}) => {
  return {
    type: UPDATE_PROJECTS_IMPORTANT_PAGE,
    payload: {
      resource: 'project-important-pages',
      onSuccess: updateProjectsImportantPagesSuccess,
      afterSuccess: toggleProjectImportantPageForm,
      ...payload,
      entityPrimaryKey: 'pageId',
    },
    values,
  };
};

// Update projects important pages if updating is succeed
export const updateProjectsImportantPagesSuccess = (pages) => {
  return {
    type: UPDATE_PROJECTS_IMPORTANT_PAGE_SUCCESS,
    pages,
  };
};

// Begin updating of the projects important pages
export const batchUpdateProjectsImportantPages = (values = {}, payload = {}) => {
  return {
    type: BATCH_UPDATE_PROJECTS_IMPORTANT_PAGE,
    payload: {
      resource: 'project-important-pages/batch-update',
      onSuccess: batchUpdateProjectsImportantPagesSuccess,
      ...payload,
    },
    values,
  };
};

// Update projects important pages if updating is succeed
export const batchUpdateProjectsImportantPagesSuccess = (values) => {
  return {
    type: BATCH_UPDATE_PROJECTS_IMPORTANT_PAGE_SUCCESS,
    values,
  };
};

export const deleteProjectsImportantPage = (pageId) => {
  return {
    type: DELETE_PROJECTS_IMPORTANT_PAGE,
    payload: {
      resource: 'project-important-pages',
      entityId: pageId,
      onSuccess: deleteProjectsImportantPageSuccess,
      onErrorMessage: getIntlMessage('request.error'),
    },
  };
};

const deleteProjectsImportantPageSuccess = (pageId) => {
  return {
    type: DELETE_PROJECTS_IMPORTANT_PAGE_SUCCESS,
    pageId,
  };
};
